import React from "react";
import Select from "react-select";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import MenuItem from "@material-ui/core/MenuItem";
import NoSsr from "@material-ui/core/NoSsr";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import { withStyles } from "@material-ui/core/styles";
import { emphasize } from "@material-ui/core/styles/colorManipulator";

import "./index.css";

const styles = theme => ({
	root: {
        flexGrow: 1
	},
	input: {
		display: "flex",
		padding: "11px 0px 6px",
		height: "auto",
        minHeight: "13px"
	},
	valueContainer: {
		display: "flex",
		flexWrap: "wrap",
		flex: 1,
		// alignItems: "center",
		fontSize: 16,
        overflow: "hidden"
	},
	chip: {
		//margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
		margin: "4px",
		// height: "auto"
	},
	chipFocused: {
		backgroundColor: emphasize(
			theme.palette.type === "black"
				? theme.palette.grey[300]
				: theme.palette.grey[700],
			0.08
        )
	},
	noOptionsMessage: {
        padding: `${theme.spacing.unit}px ${theme.spacing(2)}px`
	},
	singleValue: {
		fontSize: 13,
		// lineHeight: 1
		// perlu cek ini bermasalah tidak di yg lain. Atau mungkin aturkan biar ini bisa custom mau pakai ellipsis atau tidak
		overflow: "hidden",
		whiteSpace: "nowrap",
        textOverflow: "ellipsis"
	},
	placeholder: {
		position: "absolute",
		left: 2,
        fontSize: 16
	},
	paper: {
		position: "absolute",
		zIndex: 1,
		marginTop: theme.spacing.unit,
		left: 0,
        right: 0
	},
	divider: {
        height: theme.spacing.unit * 2
    }
});

function NoOptionsMessage(props) {
	return (
		<Typography
            className={props.selectProps.classes.noOptionsMessage}
			color="textSecondary"
			{...props.innerProps}
		>
			{props.children}
		</Typography>
	);
};

function inputComponent({ inputRef, ...props }) {
	return <div ref={inputRef} {...props} />;
};

function Control(props) {
	let inputStyle = {};
    // logic for disabled color
	if (props.selectProps.isDisabled) {
		inputStyle.backgroundColor = "#e9ecef";
	}

	return (
		<TextField
            {...props.selectProps.textFieldProps}
			fullWidth
			helperText={props.selectProps.helperText}
			disabled={props.selectProps.isDisabled}
			InputProps={{
				inputComponent,
				inputProps: {
					className: props.selectProps.classes.input,
					disabled: props.selectProps.isDisabled,
					inputRef: props.innerRef,
					children: props.children,

                    ...props.innerProps
                }
			}}
			error={props.selectProps.error}
		/>
	);
};

function Option(props) {
	return (
		<MenuItem
			// buttonRef={props.innerRef}
			selected={props.isFocused}
			component="div"
			style={{
				fontWeight: props.isSelected ? 500 : 400,
				fontSize: "13px",
                minHeight: "40px"
			}}
			{...props.innerProps}
		>
			{props.children}
		</MenuItem>
	);
};

function Placeholder(props) {
	// ini belum paham caranya ganti warna dari Typography. Sepertinya sih perlu mainan inherit
	return (
		<Typography
			className={props.selectProps.classes.placeholder}
			color="textSecondary"
			{...props.innerProps}
		>
			{props.children}
		</Typography>
	);
};

function SingleValue(props) {
	// diatur lewat ext CSS sepertinya bisa juga
	let customStyle = {};
    if (props.selectProps.isDisabled) customStyle = { color: "#9E9E9E" };

	return (
		<Typography
			className={props.selectProps.classes.singleValue}
			style={customStyle}
			{...props.innerProps}
		>
			{props.children}
		</Typography>
	);
};

function ValueContainer(props) {
	return (
		<div className={props.selectProps.classes.valueContainer}>
			{props.children}
		</div>
	);
};

// function MultiValue(props) {
//     let customStyle = {};
//     if (props.selectProps.isDisabled) customStyle.color = "#9e9e9e";

//     return (
//         <Chip
//             className={classNames(props.selectProps.classes.chip, {
//                 [props.selectProps.classes.chipFocused]: props.isFocused
//             })}
//             size="small"
//             label={props.children}
//             tabIndex={-1}
//             deleteIcon={
//                 <CancelIcon
//                     {...props.removeProps}
//                     style={{ height: "13px" }}
//                 />
//             }
//             style={customStyle}
//             onDelete={props.removeProps.onClick}
//         />
//     );
// };

function Menu(props) {
	if (props.selectProps.isLoading) {
		return (
			<Paper
				className={props.selectProps.classes.paper}
				square
				{...props.innerProps}
			>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						fontStyle: "italic",
						paddingTop: 10,
                        paddingBottom: 10
					}}
				>
					<CircularProgress />
				</div>
			</Paper>
		);
	}

	return (
		<Paper
			className={props.selectProps.classes.paper}
            square
			{...props.innerProps}
		>
			{props.children}

			{props.selectProps.showMore && !props.selectProps.showMoreIsLoading && (
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						paddingTop: 5,
                        paddingBottom: 5
					}}
				>
                    <Button onClick={props.selectProps.onShowMore}>
                        show more
                    </Button>
				</div>
			)}

			{props.selectProps.showMore && props.selectProps.showMoreIsLoading && (
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						paddingTop: 5,
                        paddingBottom: 5
					}}
				>
					<CircularProgress />
				</div>
			)}
		</Paper>
	);
};

const components = {
	Control,
	Menu,
	// MultiValue,
	NoOptionsMessage,
	Option,
	Placeholder,
	SingleValue,
    ValueContainer
};

const ReactSelectForm = props => {
	const {
		classes,
		options = [],
		placeholder = "",
		value,
        helperText = "",
		theme,
		textFieldProps,
		isMulti,
		isClearable = true,
        isDisabled,
		error = false,
		onChange,
		onFocus,

		// for async options
		defaultOptions,
		loadOptions,
        label
	} = props;

	const selectStyles = {
        input: base => ({
			...base,
			color: theme.palette.text.primary,
			padding: 0,
			margin: 0,
			"& input": {
                font: "inherit"
			},
			//cofused use or not
			display: "flex",
			flexFlow: "row wrap",
            alignItems: "center"
		}),
		indicatorsContainer: (provided, state) => {
			return {
                ...provided
			};
		},
		indicatorSeparator: (provided, state) => {
			return {
				...provided,
                margin: "0px 5px"
			};
		},
		dropdownIndicator: (provided, state) => {
			return {
				...provided,
                padding: "0px"
			};
		},
		clearIndicator: (provided, state) => {
			return {
				...provided,
				padding: "0px",
                cursor: "pointer"
			};
        }
	};

	const filterOption = (option, inputValue) => {
		// option itu isinya ada label dan value dari masing2.
		// kalua mau ambil keseluruhan, ambil di options, bukan option.
		// value ini biasanya id-nya
		const { label } = option;

		if (inputValue !== undefined)
			return label.toUpperCase().includes(inputValue.toUpperCase());
	};

	const reactSelectProps = {
		...props,
		classes,
		options,
		filterOption,
		placeholder,
		value,
		helperText,
		components,
        textFieldProps: {
            label,
            //   InputLabelProps: {
            //     shrink: value ? true : false
            //   },
            ...textFieldProps
        },
		isMulti,
		isClearable,
		isDisabled,
		backspaceRemovesValue: true,
        styles: selectStyles,
		error,
		onFocus,
		onChange,

		// for async
		defaultOptions,
        loadOptions
	};

	return (
		<div>
			<NoSsr>
				<Select {...reactSelectProps} />
			</NoSsr>
		</div>
	);
};

export default withStyles(styles, { withTheme: true })(ReactSelectForm);